// Any api.* non-POST route is proxied; locale TLD irrelevant, env not consulted.
function resolveZiggyRouteDomain(
  route: { domain?: string; methods: string[] },
  proxyBase: string,
): string | undefined {
  if (!route.domain) {
    return undefined;
  }

  if (route.domain.includes("client") || route.domain.includes("www")) {
    return "";
  }

  if (route.domain.startsWith("api.") && !route.methods.includes("POST")) {
    return proxyBase;
  }

  return route.domain;
}

export { resolveZiggyRouteDomain };
